// import { useContext } from 'react';
import ReactDom from 'react-dom';

import styled from '@emotion/styled';

import { ModalProvider } from './ModalContext';

interface IModal {
  children: React.ReactNode;
  showModal: boolean;
  setShowModal: (...args: any) => void;
  className?: string;
}

export const Modal: React.FC<IModal> = ({
  children,
  showModal,
  setShowModal,
  className,
}) => {
  const modalRoot = document.getElementById('modal-root');

  if (!showModal) return null;

  const handleBackdropClick = (e: React.MouseEvent<HTMLDivElement>) => {
    if (e.target === e.currentTarget) {
      setShowModal(false);
    }
  };

  return ReactDom.createPortal(
    <ModalContainer onClick={handleBackdropClick} className={className ?? ''}>
      <ModalProvider showModal={showModal} setShowModal={setShowModal}>
        {children}
      </ModalProvider>
    </ModalContainer>,
    modalRoot!,
  );
};

const ModalContainer = styled.div`
  position: fixed;
  overflow: auto;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  isolation: isolate;
  background: ${({ theme }) => theme.palette.modalBackdrop};
  display: grid;
  justify-content: center;
  z-index: 1000;
  /* background-color: red; */

  &.blur {
    backdrop-filter: blur(3px);
    -webkit-backdrop-filter: blur(3px);
    background-color: rgba(255, 255, 255, 0.1);
  }

  @media (max-width: 884px) {
    place-items: center;
    justify-content: normal;
    width: 100vw;
  }

  & > * {
    height: fit-content;
  }
`;
